<div class="cw-new-card bg-white w-100 {{ shadowClass }} {{ customCardClass }}" [attr.aria-label]="'Card'">
  @if (showHeader) {
    <div class="cw-new-card-header" [attr.aria-label]="'Card header'">
      <ng-content select="[header]" />
    </div>
  }
  @if (showBody) {
    <div class="cw-new-card-body" [attr.aria-label]="'Card body'">
      <ng-content select="[body]" />
    </div>
  }
  @if (showFooter) {
    <div class="cw-new-card-footer" [attr.aria-label]="'Card footer'">
      <ng-content select="[footer]" />
    </div>
  }
</div>
